import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Plane, Gamepad2, Camera, Music, Palette, BookOpen, Pen, Mountain, Dumbbell, Coffee, Wine, Beer, Cat, Dog, Mic2, ShoppingBag, Car, Film } from 'lucide-react';

const HobbiesStep = ({ data, updateData, onNext }) => {
  const [selected, setSelected] = useState(data.hobbies || []);

  const hobbies = [
    { id: 'traveling', label: 'Traveling', icon: Plane },
    { id: 'videogames', label: 'Videogames', icon: Gamepad2 },
    { id: 'photography', label: 'Photography', icon: Camera },
    { id: 'music', label: 'Music', icon: Music },
    { id: 'art', label: 'Art', icon: Palette },
    { id: 'books', label: 'Books', icon: BookOpen },
    { id: 'writing', label: 'Writing', icon: Pen },
    { id: 'hiking', label: 'Hiking', icon: Mountain },
    { id: 'working-out', label: 'Working Out', icon: Dumbbell },
    { id: 'tea', label: 'Tea', icon: Coffee },
    { id: 'wine', label: 'Wine', icon: Wine },
    { id: 'beer', label: 'Beer', icon: Beer },
    { id: 'cats', label: 'Cats', icon: Cat },
    { id: 'dogs', label: 'Dogs', icon: Dog },
    { id: 'karaoke', label: 'Karaoke', icon: Mic2 },
    { id: 'shopping', label: 'Shopping', icon: ShoppingBag },
    { id: 'cars', label: 'Cars', icon: Car },
    { id: 'theatre', label: 'Theatre', icon: Film }
  ];

  const handleToggle = (hobbyId) => {
    setSelected(prev => {
      if (prev.includes(hobbyId)) {
        const updated = prev.filter(id => id !== hobbyId);
        updateData('hobbies', updated);
        return updated;
      } else {
        const updated = [...prev, hobbyId];
        updateData('hobbies', updated);
        return updated;
      }
    });
  };

  return (
    <div className="text-center">
      <h1 className="text-white text-2xl md:text-3xl font-bold mb-4">
        Choose hobbies for your AI girlfriend
      </h1>
      <p className="text-white/70 text-sm md:text-base mb-8">
        Choose as many as you want
      </p>

      <div className="grid grid-cols-3 gap-3 mb-8 max-h-[50vh] overflow-y-auto">
        {hobbies.map((hobby) => {
          const IconComponent = hobby.icon;
          const isSelected = selected.includes(hobby.id);
          return (
            <button
              key={hobby.id}
              onClick={() => handleToggle(hobby.id)}
              className={`py-4 px-3 rounded-2xl text-sm font-bold transition-all duration-300 hover:scale-105 flex flex-col items-center justify-center gap-2 ${
                isSelected
                  ? 'bg-[#F1B428] text-black shadow-lg shadow-[#F1B428]/30 scale-105'
                  : 'bg-white/5 backdrop-blur-sm text-white border border-white/10 hover:border-[#F1B428]/50'
              }`}
            >
              <IconComponent size={20} />
              {hobby.label}
            </button>
          );
        })}
      </div>

      <Button
        onClick={onNext}
        disabled={selected.length === 0}
        className="w-full max-w-sm bg-[#F1B428] hover:bg-[#D9A022] text-black font-bold text-lg py-6 rounded-full transition-all duration-300 hover:scale-105 shadow-lg shadow-[#F1B428]/30 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Continue
      </Button>
    </div>
  );
};

export default HobbiesStep;
